export enum FRANCHISE_LETTER_STATUS{
   CAN_REQUEST_FRANCHISE_LETTER = '0',
   FRANCHISE_LETTER_IS_IN_PROGRESS = '1',
   FRANCHISE_LETTER_IS_DONE = '2',
   CANNOT_REQUEST_FRANCHISE_LETTER= '-1'
}
